import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicSiteConfigService } from '../../services/public-site-config.service';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrl: './landing-header.component.scss'
})
export class LandingHeaderComponent implements OnInit {
  mainSiteUrl = '';

  constructor(private router: Router, private publicSiteCfg: PublicSiteConfigService) {}

  ngOnInit(): void {
    this.publicSiteCfg.getSiteUrls().subscribe({
      next: (cfg) => {
        this.mainSiteUrl = (cfg?.mainSiteURL || '').trim();
      },
      error: () => {
        this.mainSiteUrl = '';
      }
    });
  }

  goHome(): void {
    this.router.navigate(['/']).then(() => {
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
    });
  }

  navigateTo(anchorId: string): void {
    const url = this.router.url || '';
    const onHome = url === '/' || url.startsWith('/#') || /^\/(\?|$)/.test(url);

    if (onHome) {
      const elem = document.getElementById(anchorId);
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    this.router.navigate(['/'], { fragment: anchorId }).then(() => {
      setTimeout(() => document.getElementById(anchorId)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
    });
  }
}
